import Page from "../../classes/Page";
import { mapEach } from "../../utils/dom";
import { delay, blockDelay, nestedDelay } from "../../utils/math";

export default class extends Page {
  constructor() {
    super({
      classes: {
        active: "experience--active",
        pageActive: "page--active",
      },
      element: ".experience",
      elements: {
        wrapper: ".experience__wrapper",
        blocks: ".c-section",
        footer: ".c-section__footer",
        nav: ".c-nav",
        form: ".c-form",
      },
    });
  }

  async show() {
    this.element.classList.add(this.classes.active);
    this.element.classList.add(this.classes.pageActive);

    return super.show();
  }

  async hide() {
    this.element.classList.remove(this.classes.active);
    this.element.classList.remove(this.classes.pageActive);

    await delay(400);

    return super.hide();
  }

  onResize() {
    super.onResize();
  }

  update() {
    super.update();
  }
}
